const MessageUtils = {
  getMessageValue: function(messageList, messageKey, args) {
    if (!messageList)
      return ''

    let filtered = messageList.filter(message => message.key === messageKey)
    if (filtered.length === 0)
      return messageKey

    let final = filtered[0].value

    if (! args)
      return final

    for (const [index, value] of args.entries())
      final = final.replace('{' + index + '}', value)

    return final
  },
  getUnknownError: function(messageList) {
    let errorList = [];
    errorList.push(
      {fieldName: null, message: MessageUtils.getMessageValue(messageList, "c_unknown_error")}
    )
    return errorList;
  },
  truncate: function(str, n) {
    if (!str) {
      return "";
    }
    return (str.length > n) ? str.substr(0, n-1) + '…' : str;
  },
}

export default MessageUtils
